import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { route } from "../routes";
import config from "../config";
import OptionsContext from '../contexts/options';
import FilterForm from "../components/FilterForm";
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import {
  withRouter,
  GelContentContainer,
  GelContentColumn,
  GelContentRow,
  HeroBlock,
  ResultsCounter,
  ResultsSort,
  ResultsGroupSize,
  Link,
  GoogleMap,
  Pagination,
  ResultsHeader,
  SimpleTabs
} from "cw-styleguide-react";
import { Helmet } from "react-helmet";

class ResultsView extends Component {
  constructor(props) {
    super(props);

    this.handleViewDetails = this.handleViewDetails.bind(this);
  }

  componentDidMount() {
    window.document.addEventListener('googleMapMarkerViewDetails', this.handleViewDetails, false);
  }

  componentWillUnmount() {
    window.document.removeEventListener('googleMapMarkerViewDetails', this.handleViewDetails, false);
  }

  handleViewDetails(e) {
    if (e.detail.url) {
      this.props.navigate(route('detail', { apprenticeship: e.detail.url }));
    }
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.results.metaTitle')} | {this.props.t('app.name')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.t('view.results.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          <p>{this.props.t('view.results.introduction')}</p>
        </HeroBlock>
        <BreadcrumbsItem to={route('results') + this.props.query}>{this.props.t('breadcrumbs.results')}</BreadcrumbsItem>
        <GelContentContainer>
          <SimpleTabs active={this.props.view} query={this.props.query} tabs={[
            {
              id: 'LIST', title: this.props.t('view.results.tabs.list'), onClick: ((e) => {
                this.props.setView('LIST')
              })
            },
            {
              id: 'MAP', title: this.props.t('view.results.tabs.map'), onClick: ((e) => {
                this.props.setView('MAP')
              })
            }
          ]} />
          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
              <FilterForm
                filters={this.props.filters}
                setFilter={this.props.setFilter}
                addFilter={this.props.addFilter}
                removeFilter={this.props.removeFilter}
                resetFilters={this.props.resetFilters}
                isLoadingApprenticeships={this.props.isLoadingApprenticeships}
                isMobile={this.props.isMobile}
                setQuery={this.props.setQuery}
                loadApprenticeships={this.props.loadApprenticeships}
                resetQuery={this.props.resetQuery}
                convertFiltersToParameters={this.props.convertFiltersToParameters}
              />
            </GelContentColumn>
            <GelContentColumn xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>
              {this.props.view === 'LIST' &&
                <OptionsContext.Consumer>
                  {({ apprenticeshipLevels }) => (
                    <Fragment>
                      <ResultsCounter count={this.props.total}>
                        <span>{this.props.t('misc.results')}</span>
                      </ResultsCounter>
                      <ResultsHeader>
                        {this.props.apprenticeships.length !== 0 &&
                          <Fragment>
                            <ResultsGroupSize label={this.props.t('styleguide:forms.groupSize.label')} value={this.props.groupSize}
                              onChange={(e) => this.props.setGroupSize(e.target.value)} options={[
                                { value: '10', label: this.props.t('styleguide:forms.groupSize.options.ten') },
                                { value: '20', label: this.props.t('styleguide:forms.groupSize.options.twenty') },
                                { value: '50', label: this.props.t('styleguide:forms.groupSize.options.fifty') }
                              ]}
                            />
                            <ResultsSort label={this.props.t('filters.sortBy.label')} value={this.props.sort}
                              onChange={(e) => this.props.setSort(e.target.value)} options={[
                                { value: 'closingDateAsc', label: this.props.t('filters.sortBy.options.closingDateSoon') },
                                { value: 'closingDateDesc', label: this.props.t('filters.sortBy.options.closingDateLater') },
                                { value: 'dateCreatedAsc', label: this.props.t('filters.sortBy.options.dateCreatedSoon') },
                                { value: 'dateCreatedDesc', label: this.props.t('filters.sortBy.options.dateCreatedLater') },
                                { value: 'distanceNearest', label: this.props.t('filters.sortBy.options.distanceNearer') },
                                { value: 'distanceFurthest', label: this.props.t('filters.sortBy.options.distanceFurthest') }
                              ]}
                            />
                          </Fragment>
                        }
                      </ResultsHeader>
                      {this.props.apprenticeships.length === 0 &&
                        <div dangerouslySetInnerHTML={{ __html: this.props.t('misc.noResults') }} />
                      }
                      {this.props.apprenticeships.map((apprenticeship, index) => {
                        return (
                          <div key={index}>
                            <h2 className={'gel-xs-mb-10 gel-sm-mb-10 gel-md-mb-10 gel-lg-mb-10 gel-xl-mb-10'}>
                              <Link to={route('detail', { apprenticeship: apprenticeship.slug })}>
                                {apprenticeship.title}
                              </Link>
                            </h2>
                            <span><strong>{this.props.t('view.results.labels.id')}:</strong> {apprenticeship.id}</span><br />
                            <span><strong>{this.props.t('view.results.labels.employer')}:</strong> {apprenticeship.employer}</span><br />
                            <span><strong>{this.props.t('view.results.labels.location')}:</strong> {apprenticeship.location}</span><br />
                            <span><strong>{this.props.t('view.results.labels.level')}:</strong> {apprenticeshipLevels.find(level => level.value === apprenticeship.apprenticeshipLevel.toString())?.name}</span><br />
                            <span><strong>{this.props.t('view.results.labels.pay')}:</strong> {apprenticeship.payDetails}</span><br />
                            <span><strong>{this.props.t('view.results.labels.closing')}:</strong> {moment(apprenticeship.closingDate).format('DD/MM/YYYY')}</span>
                          </div>
                        );
                      })}
                      <Pagination total={this.props.total} limit={this.props.groupSize} />
                    </Fragment>
                  )}
                </OptionsContext.Consumer>
              }
              {this.props.view === 'MAP' &&
                <Fragment>
                  <ResultsCounter count={this.props.total}>
                    <span>{this.props.t('misc.results')}</span>
                  </ResultsCounter>
                  {this.props.apprenticeships.length === 0 &&
                    <div dangerouslySetInnerHTML={{ __html: this.props.t('misc.noResults') }} />
                  }
                  {this.props.markers.length > 0 &&
                    <GoogleMap markers={this.props.markers} apiKey={config.googleMapsApiKey} />
                  }
                </Fragment>
              }
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withRouter(withTranslation('local')(ResultsView));
